var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-async-error"},[_vm._v("\n  Sorry, Fail to load component !\n")])}
var staticRenderFns = []

export { render, staticRenderFns }